export default __webpack_public_path__ + "static/media/txyun.b4d54fa5.svg";